module.exports = __webpack_public_path__ + "img/lawdetcover_sample.8d1e06a0.png";